import { inject, observer } from 'mobx-react';
import React from 'react';
import VariantSnackbar from './VariantSnackbar';

@inject('mensagemStore')
@observer
class MensagemSnackbar extends React.Component {
  render () {
    return (
      <VariantSnackbar
        vertical={'bottom'}
        horizontal={'right'}
        duration={this.props.mensagemStore.duracao}
        variant={this.props.mensagemStore.variant}
        message={this.props.mensagemStore.conteudo}
        open={this.props.mensagemStore.exibir}
        handleClose={this.props.mensagemStore.fecharMensagem} />
    );
  }
}

export default MensagemSnackbar;
